import cloneDeep from 'lodash/cloneDeep'

import {parsePipeline} from '../../../EditPipelinePage.utils'
import schemaJson from '../schema.json'

import getJsonSchemaJobDependencies from './getJsonSchemaJobDependencies'

function getJsonSchemaJobs(currentYaml: string) {
  let properties = {}
  let filesPublication: string[] = []

  try {
    const yaml = parsePipeline(currentYaml)
    if (yaml?.jobs != null) {
      const jobs = yaml.jobs

      properties = Object.keys(jobs).reduce((acc, jobName) => {
        const clonedJobSchema = cloneDeep(schemaJson.definitions.job)
        const jobDependencies = getJsonSchemaJobDependencies(jobs, jobName)
        const availableArtifacts = jobs[jobName]?.['files-publication'] || []

        filesPublication = filesPublication.concat(availableArtifacts)

        clonedJobSchema.properties.dependencies = {
          ...clonedJobSchema.properties.dependencies,
          ...jobDependencies,
        }

        return {...acc, [jobName]: clonedJobSchema}
      }, {})
    }
  } catch {
    properties = {}
  }

  return {jobs: properties, filesPublication}
}

export default getJsonSchemaJobs
